import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Meta } from "../../Components/Helpers/Meta";
import { useParams, Link } from "react-router-dom";
import InvestorSidebar from "../../Components/InvestorSidebar/InvestorSidebar";
import "./Announcements.style.css"; // aynı stil
import { Announcements } from "./Announcements";


const PressAnnouncements = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const L = i18next.language?.startsWith("tr") ? "tr" : "en";

  const parseDate = (d) => {
    const [dd, mm, yyyy] = d.split(".").map(Number);
    return new Date(yyyy, (mm || 1) - 1, dd || 1);
  };

  const items = Announcements
    .filter(a => !a.is_special)
    .sort((a, b) => parseDate(b.date) - parseDate(a.date));

  const linkFor = (a) => {
    return L === "tr"
      ? `/${L}/duyurular/${a.link_tr || a.link}`
      : `/announcements/${a.link || a.link_tr}`;
  };

  return (
    <div>
      <Meta title={t("press-announcements") || "Press Announcements"} description={t("press-announcements") || "Press Announcements"} lang={lang} />
      <Navbar />

      <div className="c-wrapper">
        <div className="c-hero">
          <div className="c-hero-background">
            <picture>
              <img className="c-hero-image" alt="" src={require("../../assets/hero/public-offering.jpg")} style={{ width: "100%" }} />
            </picture>
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div className="c-caption-section" style={{ color: "#000", textAlign: "center" }}>
                {t("investor-relations")}
              </div>
              <h1 className="c-caption-header" style={{ color: "#000" }}>
                {t("press-announcements") || "Press Announcements"}
              </h1>
            </div>
          </div>
        </div>

        <div className="po-container">
          <InvestorSidebar />

          <main className="pol-content">
            <section className="pol-card">
              <table className="ann-table" aria-label={t("press-announcements") || "Press Announcements"}>
                <tbody>
                  {items.map((a, i) => (
                    <tr key={i} className="ann-row">
                      <td className="ann-td ann-td--date">{a.date}</td>
                      <td className="ann-td ann-td--title">
                        <Link to={linkFor(a)} className="ann-rowlink">
                          {L === "tr" ? (a.title_tr || a.title) : (a.title || a.title_tr)}
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </section>
          </main>
        </div>
      </div>
    </div>
  );
};

export default PressAnnouncements;
